import { getChallengeStarHiscores as getChallengeStarHiscoresFromDb } from "@dailywars/core/db";
import { createServerFn } from "@tanstack/react-start";

import { setRouteAction } from "#/lib/requestLogger.server";
import { getChallengeStarHiscoresInputSchema } from "#/lib/serverInputSchemas";

const HISCORES_PAGE_SIZE = 100;

export const getChallengeStarHiscores = createServerFn({ method: "GET" })
  .validator(getChallengeStarHiscoresInputSchema)
  .handler(async ({ data }) => {
    setRouteAction("challenge_star_hiscores");
    return getChallengeStarHiscoresFromDb({
      limit: HISCORES_PAGE_SIZE,
      cursor: data.cursor,
    });
  });
